import React, { useState } from "react";
import { Wrapper, Content, Row, MLabel, InputText, TextArea, Footer, InputNumber, VisuallyHiddenInput, MButton } from './styles'
import { useInventoryNew } from "./useInventoryNew";
import MessageBox from "components/MessageBox";
import { INV_GOODS_UNIT, MESSAGE } from "Common";
import { Box, Button, FormControl, MenuItem, Select } from "@mui/material";
import { faForward } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "components/Loading";
import HeaderBox from "components/HeaderBox";
import SelectClientGoods from "components/SelectClientGoods";
import { CompressImage } from "Compress";
import ButtonBack from "components/ButtonBack";

const InventoryNew = () => {
    const [gName, setGName] = useState("");
    const [gKana, setGKana] = useState("");
    const [gSize, setGSize] = useState("");
    const [stockQ, setStockQ] = useState(0);
    const [stockQMemo, setStockQMemo] = useState("");
    const [shelfName, setShelfName] = useState("");
    const [invGoodsMemo, setInvGoodsMemo] = useState("");
    const [imgSrc, setImgSrc] = useState(null);

    //Morien Goods
    const [goodsID, setGoodsID] = useState(1);
    const [goodsSubID, setGoodsSubID] = useState(1);
    const [gImgUrl, setGImgUrl] = useState("");

    const [showSelectMorienGoods, setShowSelectMorienGoods] = useState(false);


    const { setInvGoodsInfo, isLoading, setIsLoading
        , message, setMessage
        , navigate
    } = useInventoryNew();

    const handleRegister = () => {
        //Validate Data
        //gName, gSize, stockQ
        if (!gName || !gSize || stockQ < 1) {
            const msg = { type: MESSAGE.ERROR, contents: ['必須項目を入力してください。'] };
            setMessage(msg);
            return;
        }
        console.log("first");

        //set InvGoods Info
        setInvGoodsInfo({
            GoodsID: goodsID,
            GoodsSubID: goodsSubID,
            GoodsName: gName,
            GoodsKana: gKana,
            GoodsSize: gSize,
            StockQuantity: stockQ,
            StockQuantityMemo: stockQMemo,
            ShelfName: shelfName,
            InvGoodsMemo: invGoodsMemo,
            GoodsImage: imgSrc?.file || null,
            MGoodsImageUrl: gImgUrl || "",
        });


    }
    const handleUploadImage = async (target) => {
        if (!target.files || target.files.length !== 1) return;
        try {
            setIsLoading(true);
            const uploadedFile = Array.from(target.files)[0];
            const compressedFiles = await CompressImage(uploadedFile);
            setImgSrc(compressedFiles);
        } catch (error) {
            const msg = { type: MESSAGE.ERROR, contents: [error.toString()] };
            setMessage(msg);
        } finally {
            setIsLoading(false);
        }
    }

    const handleSelectedMorienGoods = (item) => {
        if (!item) return;
        setGoodsID(item.GoodsID);
        setGoodsSubID(item.GoodsSubID);
        setGName(item.GoodsName || "");
        setGKana(item.GoodsKana || "");
        setGSize(item.GoodsSize || "");
        setGImgUrl(item.GoodsImageUrl || "");
    }

    const handleClearMorienGoods = () => {
        setGoodsID(1);
        setGoodsSubID(1);
        setGKana("");
        setGImgUrl("");
    }

    return (
        <Wrapper>
            <Loading isLoading={isLoading} />
            <HeaderBox title="新規登録（在庫）" haveCart={false} />
            <Content>
                <Row column>
                    <MLabel>商品名<span style={{ color: "#f00" }}>*</span>：</MLabel>
                    <InputText
                        maxLength={64}
                        // placeholder={'商品名'}
                        value={gName}
                        onChange={(e) => { setGName(e.target.value); handleClearMorienGoods(); }}
                    />

                    <Box sx={{ textAlign: "right", pr: 1, fontSize: "0.9rem" }}>
                        <Button sx={{ py: 0 }} onClick={() => { setShowSelectMorienGoods(true); }} >
                            モリエンの商品から選ぶ <FontAwesomeIcon style={{ color: "#009527", paddingLeft: 4 }} icon={faForward} />
                        </Button>
                    </Box>
                </Row>
                <Row column>
                    <MLabel>サイズ<span style={{ color: "#f00" }}>*</span>：</MLabel>
                    <InputText
                        maxLength={12}
                        width={'120px'}
                        // placeholder={'サイズ'}
                        value={gSize}
                        onChange={(e) => { setGSize(e.target.value); handleClearMorienGoods(); }}
                    />

                </Row>
                <Row column>
                    <MLabel>在庫数<span style={{ color: "#f00" }}>*</span>：</MLabel>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <InputNumber
                            width={'80px'}
                            maxLength={5}
                            value={stockQ < 1 ? '' : stockQ}
                            style={{ textAlign: "right" }}
                            onChange={(e) => { setStockQ(parseInt(e.target.value)); }}
                        />
                        <MLabel style={{ fontSize: "0.8rem", }}>単位：</MLabel>
                        <FormControl sx={{ minWidth: 60, }} size="small">
                            <Select
                                labelId="demo-select-small-label"
                                id="demo-select-small"
                                value={stockQMemo}
                                onChange={(e) => { setStockQMemo(e.target.value) }}
                                sx={{
                                    height: 28, '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'gray', // đổi màu viền ở đây
                                    },
                                }}
                            >
                                <MenuItem value={""}></MenuItem>
                                {INV_GOODS_UNIT.map((unit, index) => (
                                    <MenuItem key={unit} value={unit}>{unit}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </Row>
                <Row column>
                    <MLabel>在庫メモ：</MLabel>
                    <TextArea
                        maxLength={200}
                        rows={4}
                        value={invGoodsMemo}
                        onChange={(e) => { setInvGoodsMemo(e.target.value); }}
                    />
                </Row>
                <Row column>
                    <MLabel>保存場所：</MLabel>
                    <InputText
                        maxLength={50}
                        // placeholder={'保存場所'}
                        value={shelfName}
                        onChange={(e) => { setShelfName(e.target.value) }}
                    />

                </Row>
                <Row >
                    <MLabel>商品画像：</MLabel>
                    <Button component="label" variant="outlined" size="small" sx={{ minWidth: "50px" }}>選択
                        <VisuallyHiddenInput type="file"
                            accept="image/*"
                            value={""}
                            onChange={(event) => { handleUploadImage(event.target) }}
                        />
                    </Button>
                    {(!!imgSrc?.url) && (<Button variant="outlined" size="small" color="secondary"
                        sx={{ minWidth: "50px", ml: 1 }} onClick={() => { setImgSrc(null); }}>削除</Button>)}
                </Row>
                <Box sx={{ width: "100%", textAlign: "center", mt: 0.5 }}>
                    {(!!imgSrc?.url || !!gImgUrl) && (<Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Box component={"img"}
                            sx={{ height: 80, width: "auto", mb: 1 }}
                            alt='商品画像' src={imgSrc?.url || gImgUrl} />
                    </Box>)}
                </Box>
                <Footer>
                    <MButton onClick={() => { handleRegister(); }}>登録</MButton>
                </Footer>
            </Content>
            <MessageBox message={message} setMessage={setMessage} />
            <SelectClientGoods handleSelected={handleSelectedMorienGoods}
                setIsLoading={setIsLoading}
                setMessage={setMessage}
                open={showSelectMorienGoods}
                handleClose={() => { setShowSelectMorienGoods(false); }}
            />
            <ButtonBack onHandleBack={() => { navigate(-1) }} />
        </Wrapper>
    )
}

export default InventoryNew;